const authorFromScratch = {
  roleplayId: "nualang.author-from-scratch.0.0.1",
  roleplayName: "Create Your Own",
  description: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-pencil-alt?fontSize=200`,
  difficulty: "ALL",
  learnLang: "chinese",
  actor1: {
    name: "",
    voice: "",
    picture: "",
  },
  actor2: {
    name: "",
    voice: "",
    picture: "",
  },
  script: [],
};

export default authorFromScratch;
